import * as types from '../mutation-types'
import api from '@/api/company'

// initial state
const state = {
  capgeminiCompany: null,
  capgeminiCompanyLoaded: false,
  capgeminiCompanySlug: null,
}

const getters = {
  capgeminiCompany: state => state.capgeminiCompany,
  capgeminiCompanyLoaded: state => state.capgeminiCompanyLoaded,
  capgeminiCompanySlug: state => state.capgeminiCompanySlug,
}

const actions = {
  getCapgeminiCompany({ commit }, { query, urlSlug, cb }) {
    commit(types.SET_CAPGEMINI_COMPANY_LOADED, true);
    commit(types.SET_CAPGEMINI_COMPANY_SLUG, urlSlug || query._slug);
    console.log('Query Slug:', query)
    let slug = query._slug
    console.log('Replaced slug:', slug)
    api.getCapgeminiCompany(slug, (response) => {
      commit(types.SET_CAPGEMINI_COMPANY, response);
      commit(types.SET_CAPGEMINI_COMPANY_LOADED, true);
      cb(response);
    })
  },
}

const mutations = {
  [types.SET_CAPGEMINI_COMPANY](state, data) {
    state.capgeminiCompany = data
  },
  [types.SET_CAPGEMINI_COMPANY_LOADED](state, status) {
    state.capgeminiCompanyLoaded = status
  },
  [types.SET_CAPGEMINI_COMPANY_SLUG](state, data) {
    state.capgeminiCompanySlug = data
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}


